import { CREATED_AT, DEFAULT_ATTRIBUTES, RESULT, UID } from 'shared/api/query/constants';
import {
  asanaQuery as asanaQueryConfig,
  azureDevOpsQuery as azureDevOpsQueryConfig,
  comment as commentConfig,
  dataSource as dataSourceConfig,
  feedEntry as feedEntryConfig,
  goal as goalConfig,
  hubspotQuery as hubspotQueryConfig,
  jiraQuery as jiraQueryConfig,
  msPlannerQuery as msPlannerQueryConfig,
  msPowerBiQuery as msPowerBiQueryConfig,
  notification as notificationConfig,
  printable as printableConfig,
  property as propertyConfig,
  propertyValue as propertyValueConfig,
  report as reportConfig,
  salesforceQuery as salesforceQueryConfig,
  spreadsheetCell as spreadsheetCellConfig,
  storageObject as storageObjectConfig,
  update as updateConfig,
  updateTemplate as updateTemplateConfig,
  user as userConfig,
} from 'shared/api/query/configs.json';
import { commentEdges } from '@/api/query/nebula/comment';
import { storageObjectEdges } from '@/api/query/nebula/storage-object';
import { updateChildren } from '@/api/query/nebula/update';

export const feedEntryChildren = [
  ...DEFAULT_ATTRIBUTES,
  { attr: feedEntryConfig.edges.readAt },
  { attr: feedEntryConfig.edges.fulfilledAt, default: null },
  { attr: feedEntryConfig.edges.type },
  {
    attr: feedEntryConfig.edges.actor,
    model: userConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.goal,
    model: goalConfig.model,
    default: null,
    children: [{ attr: UID }, { attr: goalConfig.edges.title, default: '' }],
  },
  {
    attr: feedEntryConfig.edges.update,
    model: updateConfig.model,
    default: null,
    children: updateChildren(),
  },
  {
    attr: feedEntryConfig.edges.comment,
    model: commentConfig.model,
    default: null,
    children: commentEdges,
  },
  {
    attr: feedEntryConfig.edges.notification,
    model: notificationConfig.model,
    default: null,
    children: [
      { attr: UID },
      { attr: notificationConfig.edges.title },
      {
        attr: notificationConfig.edges.updateTemplate,
        model: updateTemplateConfig.model,
        default: null,
        children: [{ attr: UID }],
      },
    ],
  },
  {
    attr: feedEntryConfig.edges.propertyValue,
    model: propertyValueConfig.model,
    default: null,
    children: [
      { attr: UID },
      {
        attr: propertyValueConfig.edges.property,
        model: propertyConfig.model,
        default: null,
        children: [{ attr: UID }],
      },
    ],
  },
  {
    attr: feedEntryConfig.edges.printable,
    model: printableConfig.model,
    default: null,
    children: [
      { attr: UID },
      {
        attr: printableConfig.edges.report,
        model: reportConfig.model,
        default: null,
        children: [{ attr: UID }],
      },
      {
        attr: printableConfig.edges.storageObject,
        model: storageObjectConfig.model,
        default: null,
        children: storageObjectEdges,
      },
    ],
  },
  {
    attr: feedEntryConfig.edges.dataSource,
    model: dataSourceConfig.model,
    default: null,
    children: [
      { attr: UID },
      { attr: dataSourceConfig.edges.name, default: '' },
      { attr: dataSourceConfig.edges.type },
    ],
  },
  {
    attr: feedEntryConfig.edges.spreadsheetQuery,
    model: spreadsheetCellConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.asanaQuery,
    model: asanaQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.jiraQuery,
    model: jiraQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.hubspotQuery,
    model: hubspotQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.salesforceQuery,
    model: salesforceQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.msPowerBiQuery,
    model: msPowerBiQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.msPlannerQuery,
    model: msPlannerQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: feedEntryConfig.edges.azureDevOpsQuery,
    model: azureDevOpsQueryConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  { attr: feedEntryConfig.edges.dataSourceQueryError, default: null },
];

export const feedEntryList = ({ alias, types, pagination }) => [{
  func: { name: 'type', args: [{ value: feedEntryConfig.model }] },
  alias,
  filter: {
    func: {
      name: 'eq',
      attr: feedEntryConfig.edges.type,
      args: types.map((t) => ({ value: t })),
    },
  },
  model: feedEntryConfig.model,
  order: [{ attr: CREATED_AT, desc: true }],
  children: feedEntryChildren,
  pagination,
  default: [],
}];

export const unreadCount = {
  func: { name: 'type', args: [{ value: feedEntryConfig.model }] },
  alias: RESULT,
  filter: {
    op: 'and',
    child: [
      {
        op: 'not',
        child: [
          {
            func: {
              name: 'has',
              attr: feedEntryConfig.edges.readAt,
            },
          },
        ],
      },
    ],
  },
  model: feedEntryConfig.model,
  children: [{ attr: 'uid' }, { attr: feedEntryConfig.edges.type }],
  default: [],
};
